<template>
  <DialogLayout
    title="料金計算"
    :visible.sync="dialogVisible"
    width="45em"
    @open="open"
  >
    <template #form>
      <CalculationForm
        ref="calculationForm"
        v-model="calculationFormModel"
        action="/calculation-fees-for-security"
        billingYmMode="this"
      />
    </template>
    <template #footer>
      <CalculationDialogFooter
        @calculation="clickCalculation"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import CalculationForm from '@/components/organisms/dialog/CalculationForm.vue'
import CalculationDialogFooter from '@/components/organisms/dialog/CalculationDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    CalculationForm,
    CalculationDialogFooter
  },
  mixins: [
  ],
  props: {
    visible: Boolean
  },
  data () {
    return {
      calculationFormModel: {
        billing_ym: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    async clickCalculation () {
      this.$loadingMask.on()
      const params = { ...this.calculationFormModel }
      var value = []
      await this.$axios
        .get('/code-master', { params: { code_id: 'SECURITY_CALC_LAMBDA_CHANGE_FLAG' } })
        .then((res) => {
          value = res.data.list
          console.log(value)
          console.log(value[0].code_value)
        })
        .catch((e) => {
          console.log(e)
        })
      await this.$refs.calculationForm.validate()
        .then((valid) => {
          // 汎用コードマスタからの値が1の時、税抜き単価計算Lambdaへ
          if (value[0].code_value === '1') {
            console.log('税抜き単価')
            return this.$axios.put('/calculation-fees-for-security-unit-price-without-tax', params)
          } else {
            console.log('税込み単価')
            return this.$axios.put('/calculation-fees-for-security', params)
          }
        })
        .then((res) => {
          if (res.status === 202) {
            this.$fcMessage.showMessage({
              id: 'CAL0001I',
              link: {
                fileName: 'warning.txt',
                messages: res.data.message
              }
            }, true)
          } else {
            this.$fcMessage.showMessage(res.data.message)
          }
          this.dialogVisible = false
          this.$emit('refresh', this.calculationFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    open () {
      console.log('FeesForSecurityCalculationDialog.open')
      this.$nextTick(function () {
        console.log(this.$refs.calculationForm)
        this.$refs.calculationForm.clear()
      })
    }
  }
}
</script>

<style lang="scss">
</style>
